import React, { Component, PropTypes } from 'react';
import moment from 'moment';

import { getStartEndTimesBasedOnBookingStatus } from '../../util/bookingHelpers';
import BookingCalendarEntryContainer from '../../containers/BookingCalendarEntryContainer';
import './CalendarDay.css';

export default class CalendarDay extends Component {
    static propTypes = {
        bookings: PropTypes.array,
    }

    render() {
        const { bookings } = this.props;
        const bookingsJsx = bookings.map((booking, i) => {
            return (
                <BookingCalendarEntryContainer
                    key={i}
                    booking={booking}
                />
            );
        });

        const firstBooking = bookings.length > 0 ? bookings[0] : null;
        let calendarDayClasses = `calendar-day`;
        let jsx;

        if (firstBooking) {
            const { start } = getStartEndTimesBasedOnBookingStatus(firstBooking);
            const day = moment(start).startOf(`d`);
            const date = start.date();
            const month = start.format(`MMM`);
            let title = start.format(`dddd`);

            if (day.isSame(moment().startOf(`d`))) {
                calendarDayClasses += ` current-day`;
                title = `Today`;
            } else if (day.isSame(moment().add(1, `d`).startOf(`d`))) {
                title = `Tomorrow`;
            }

            jsx = (
                <div className={calendarDayClasses}>
                    <div className="cd-left-content">
                        <h3>{month}</h3>
                        <h1>{date}</h1>
                    </div>
                    <div className="cd-right-content">
                        <h1 className="day-title">{title}</h1>
                        <div className="today-circle"></div>
                        {bookingsJsx}
                    </div>
                </div>
            );
        }

        return jsx;
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Calendar/CalendarDay.jsx